module.exports = __webpack_public_path__ + "media/home/eStore_Icon_OurHistory-14e263cb.png";